import { createSlice } from '@reduxjs/toolkit';
import { apiCallBegan } from 'client/store/middleware/api/api';

const apiKey = createSlice({
  name: 'apiKey',
  initialState: {
    isLoading: false,
    apiKeys: [] as string[],
    error: null,
  },
  reducers: {
    apiKeysRequested: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    apiKeysRecieved: (state, action) => {
      state.isLoading = false;
      state.apiKeys = action.payload;
    },
    apiKeysFailed: (state, action) => {
      state.isLoading = false;
      state.error = action.payload.message;
    },
  },
});

export const {
  apiKeysRequested,
  apiKeysRecieved,
  apiKeysFailed,
} = apiKey.actions;

export default apiKey.reducer;

export const getApiKeys = () => apiCallBegan({
  url: '/auth/api-keys',
  method: 'GET',
  onStart: apiKeysRequested.type,
  onSuccess: (response: string[]) => ({
    type: apiKeysRecieved.type,
    payload: response,
  }),
  onError: apiKeysFailed.type,
});
